import { render, staticRenderFns } from "./PendingReverse.vue?vue&type=template&id=338f1846&scoped=true&"
import script from "./PendingReverse.vue?vue&type=script&lang=js&"
export * from "./PendingReverse.vue?vue&type=script&lang=js&"
import style0 from "./PendingReverse.vue?vue&type=style&index=0&id=338f1846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f1846",
  null
  
)

export default component.exports